import { createShader, colorUniform } from "./ShaderBase.js";

export const snowShader = createShader({
  customizable: [
    { uniform: "uColorTop", label: "Sky", default: "#a8d4f0" },
    { uniform: "uColorBottom", label: "Ground", default: "#ffffff" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 1.0 },
    uSpeed: { value: 0.5 },
    uColorTop: colorUniform("#a8d4f0"),
    uColorBottom: colorUniform("#ffffff"),
    uSnowDensity: { value: 0.90 },
    uSnowBrightness: { value: 1.0 },
    uGradientHeight: { value: 8.0 },
  },

  fragmentUniforms: `
    uniform vec3 uColorTop;
    uniform vec3 uColorBottom;
    uniform float uSnowDensity;
    uniform float uSnowBrightness;
    uniform float uGradientHeight;
  `,

  fragmentBody: `
    // World-space vertical gradient (bottom white, top light blue)
    // Use scaled world Y position so texture permeates 3D space
    // Floor will be solid ground color, ceiling solid sky color
    float normalizedY = (pixelatedPos.y + uGradientHeight * 0.5) / uGradientHeight;
    normalizedY = clamp(normalizedY, 0.0, 1.0);
    vec3 color = mix(uColorBottom, uColorTop, normalizedY);

    // Snow sparkle noise - use time to make pixels pop in and out
    vec3 snowPos = pixelatedPos * 50.0 + vec3(floor(uTime * uSpeed * 10.0));
    float snow = snoise(snowPos);

    // Only show snow on high noise values (sparse single pixels)
    float snowFlake = step(uSnowDensity, (snow + 1.0) * 0.5);

    // Add snow as bright white pixels
    color = mix(color, vec3(uSnowBrightness), snowFlake * 0.8);

    gl_FragColor = vec4(color, 1.0);
  `,
});
